import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { prettyMoney } from '@scramble/utils';
import { useGetEarnings } from '@/query/queries/dashboard/useGetEarnings';
import { useGetBalance } from '@/query/queries/cash/useGetBalance';
import { EMPTY_DASH } from '@/helpers/constants';
import IconChart from '@scramble/design-system/icons/pie-chart-01.svg';
import IconUp from '@scramble/design-system/icons/trend-up-01.svg';
import IconPercent from '@scramble/design-system/icons/percent-03.svg';
import s from './index.module.scss';

export const InvestmentHistory = () => {
  const { t } = useTranslation();
  const { data: earnings } = useGetEarnings();
  const { data: balance } = useGetBalance();

  const allTimeEarnings =
    earnings &&
    Number(earnings.earned) +
      Number(earnings.earned_bonuses) +
      Number(earnings.accrued);

  return (
    <div className={s.wrapper}>
      <div className={s.title}>
        {t('dashboard:investment_history.your_investment_history')}
      </div>
      <div className={s.grid}>
        <div className={s.card}>
          <div className={s.top}>
            <div className={s.header}>
              <div>
                <div className="f-body-md f-500">
                  {t('dashboard:investment_history.current_investments')}
                </div>
                <div className={classnames(s.header_desc, 'f-body-sm')}>
                  {t('dashboard:investment_history.current_investments_desc')}
                </div>
              </div>
              <div className={s.icon}>
                <img src={IconChart} alt="icon" width={20} height={20} />
              </div>
            </div>
            <div className="f-headline-xs f-500">
              {prettyMoney(balance?.invested)}
            </div>
          </div>
          <div className={s.bottom}>
            <div className={s.block}>
              <div className={s.row}>
                <div className="f-body-md">
                  {t('dashboard:investment_history.group_a')}
                </div>
                <div className="f-body-md f-500">
                  {prettyMoney(balance?.invested_group_a)}
                </div>
              </div>
              <div className={s.row}>
                <div className="f-body-md">
                  {t('dashboard:investment_history.group_b')}
                </div>
                <div className="f-body-md f-500">
                  {prettyMoney(balance?.invested_group_b)}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={s.card}>
          <div className={s.top}>
            <div className={s.header}>
              <div>
                <div className="f-body-md f-500">
                  {t('dashboard:investment_history.all_time_invested')}
                </div>
                <div className={classnames(s.header_desc, 'f-body-sm')}>
                  {t('dashboard:investment_history.all_time_invested_desc')}
                </div>
              </div>
              <div className={s.icon}>
                <img src={IconUp} alt="icon" width={20} height={20} />
              </div>
            </div>
            <div className="f-headline-xs f-500">
              {earnings ? prettyMoney(earnings.invested) : EMPTY_DASH}
            </div>
          </div>
          <div className={s.bottom}>
            <div className={s.block}>
              <div className={s.row}>
                <div className="f-body-md">
                  {t('dashboard:investment_history.group_a')}
                </div>
                <div className="f-body-md f-500">
                  {earnings
                    ? prettyMoney(earnings.invested_group_a)
                    : EMPTY_DASH}
                </div>
              </div>
              <div className={s.row}>
                <div className="f-body-md">
                  {t('dashboard:investment_history.group_b')}
                </div>
                <div className="f-body-md f-500">
                  {earnings
                    ? prettyMoney(earnings.invested_group_b)
                    : EMPTY_DASH}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={s.card}>
          <div className={s.top}>
            <div className={s.header}>
              <div>
                <div className="f-body-md f-500">
                  {t('dashboard:investment_history.all_time_earnings')}
                </div>
                <div className={classnames(s.header_desc, 'f-body-sm')}>
                  {t('dashboard:investment_history.all_time_earnings_desc')}
                </div>
              </div>
              <div className={s.icon}>
                <img src={IconPercent} alt="icon" width={20} height={20} />
              </div>
            </div>
            <div className="f-headline-xs f-500">
              {earnings ? prettyMoney(allTimeEarnings) : EMPTY_DASH}
            </div>
          </div>
          <div className={s.bottom}>
            <div className={s.block}>
              <div className={s.row}>
                <div className="f-body-md">
                  {t('dashboard:investment_history.annual_rate')}
                </div>
                <div className="f-body-md f-500">
                  {earnings ? `${earnings.rate}%` : EMPTY_DASH}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
